import React, { useState } from 'react';
import Table from '../../../../app/components/Table';
import Pagination from '../../../../app/components/Pagination';
import Button from '../../../../app/components/Button';
import { FiPlus, FiEdit } from 'react-icons/fi';
import Toast from '../../../../app/components/Toast';
import FormEditDocumentTemplate from '../../../../forms/DocumentTemplates/FormEditDocumentTemplate';

const DocumentTemplates = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templates, setTemplates] = useState([
    {
      id: 1,
      nome: 'Contrato de Trabalho',
      tipo: 'Documento Word',
      arquivo: 'contrato_trabalho.docx',
    },
    {
      id: 2,
      nome: 'Relatório Mensal',
      tipo: 'Documento Word',
      arquivo: 'relatorio_mensal.docx',
    },
    {
      id: 3,
      nome: 'Política de Privacidade',
      tipo: 'Documento PDF',
      arquivo: 'politica_privacidade.pdf',
    },
    {
      id: 4,
      nome: 'Termo de Responsabilidade',
      tipo: 'Documento Word',
      arquivo: 'termo_responsabilidade.docx',
    },
  ]);

  const [filtro] = useState('');
  const [paginaAtual, setPaginaAtual] = useState(1);
  const itensPorPagina = 10;

  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

  const showToast = (type, message) => {
    setToast({ show: true, type, message });
  };


  const colunas = [
    { titulo: 'ID', campo: 'id' },
    { titulo: 'NOME', campo: 'nome' },
    { titulo: 'TIPO', campo: 'tipo' },
    { titulo: 'ARQUIVO', campo: 'arquivo' },
    { titulo: 'AÇÕES', tipo: 'acoes', centralizado: true },
  ];

  const handleEdit = (template) => {
    setSelectedTemplate(template);
    setIsFormOpen(true);
  };

  const getActionsForTemplate = (template) => [
    {
      icon: FiEdit,
      label: 'Editar',
      onClick: () => handleEdit(template)
    },
  ];

  const templatesWithActions = templates.map(template => ({
    ...template,
    acoes: getActionsForTemplate(template)
  }));

  const templatesFiltrados = filtro 
    ? templatesWithActions.filter(template => 
        template.nome.toLowerCase().includes(filtro.toLowerCase()) ||
        template.tipo.toLowerCase().includes(filtro.toLowerCase())
      )
    : templatesWithActions;

  const totalPages = Math.ceil(templatesFiltrados.length / itensPorPagina);
  const indiceInicial = (paginaAtual - 1) * itensPorPagina;
  const indiceFinal = indiceInicial + itensPorPagina;
  const templatesPaginados = templatesFiltrados.slice(indiceInicial, indiceFinal);

  const handlePageChange = (page) => {
    setPaginaAtual(page);
  };

  const handleNewTemplate = () => {
    setSelectedTemplate(null);
    setIsFormOpen(true);
  };

  const handleFormClose = () => {
    setIsFormOpen(false);
    setSelectedTemplate(null);
  };

  const handleFormSubmit = (formData) => {
    if (formData.id) {
      setTemplates(templates.map(tmpl => 
        tmpl.id === formData.id ? { ...tmpl, ...formData } : tmpl
      ));
      showToast('success', 'Template editado com sucesso!');
    } else {
      const newId = Math.max(...templates.map(tmpl => tmpl.id), 0) + 1;
      setTemplates([...templates, { ...formData, id: newId }]);
      showToast('success', 'Novo template adicionado com sucesso!');
    }
    setIsFormOpen(false);
  };


  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <Button onClick={handleNewTemplate}>
          <FiPlus size={17} />
          Cadastrar
        </Button>
        <div className="flex items-center">
          <div className="mr-4">
            {/*<h2 className="text-lg font-medium text-gray-900 flex items-center">
              <span className="mr-2 bg-gray-200 text-gray-700 text-xs font-medium rounded-full h-5 w-5 flex items-center justify-center">
                {templates.length}
              </span>
              Templates de Documento 
            </h2>*/}
          </div>
        </div>
      </div>

      <div className="overflow-x-auto -mx-3 sm:mx-0">
        <Table 
          colunas={colunas}
          dados={templatesPaginados}
        />
      </div>

      {templatesFiltrados.length > 0 && (
        <Pagination 
          currentPage={paginaAtual} 
          totalPages={totalPages} 
          onPageChange={handlePageChange}
          showPageNumbers={true}
          maxPageNumbers={5}
        />
      )}

      <FormEditDocumentTemplate 
        isOpen={isFormOpen}
        onClose={handleFormClose}
        title={selectedTemplate ? "Editar Template de Documento" : "Novo Template de Documento"}
        selectTemplate={selectedTemplate}
        onSubmit={handleFormSubmit}
      />

      {toast.show && (
        <Toast
          type={toast.type}
          message={toast.message}
          duration={3000}
          onClose={() => setToast({ ...toast, show: false })}
        />
      )}
    </div>
  );
};

export default DocumentTemplates;